export const SCHEMA_VERSION = 1;

export type TextRun = {
  readonly text: string;
  readonly bold?: boolean;
  readonly italic?: boolean;
  readonly underline?: boolean;
};

export type ParagraphBlock = {
  readonly type: "paragraph";
  readonly style?: string;
  readonly align?: string;
  readonly indent_level?: number;
  readonly text?: string;
  readonly runs?: readonly TextRun[];
  readonly bold_all?: boolean;
};

export type SectionLeadBlock = {
  readonly type: "section_lead";
  readonly label: string;
  readonly text?: string;
};

export type BulletListItem = {
  readonly text: string;
  readonly children?: readonly ContentBlock[];
};

export type NumberedListBlock = {
  readonly type: "numbered_list";
  readonly scheme?: "decimal" | "lowerLetter";
  readonly style?: string;
  readonly items: readonly string[];
};

export type BulletListBlock = {
  readonly type: "bullet_list";
  readonly style?: string;
  readonly items: readonly (string | BulletListItem)[];
};

export type ContentBlock =
  | ParagraphBlock
  | SectionLeadBlock
  | NumberedListBlock
  | BulletListBlock;

export type ContentStructure = {
  readonly schema_version: number;
  readonly blocks: readonly ContentBlock[];
};
